<template>
  <div>
    <div class="w-100 px-3 position-fixed white z-5">
      <span class="d-inline-flex my-auto">
        <v-icon @click="backToLoads()" class="my-auto mr-1 ml-6"
          >mdi-arrow-right</v-icon
        >
        <span
          class="d-inline-block my-4 high-emp subtitle1-regular"
          v-text="title"
        ></span>
      </span>
    </div>
    <div class="pt-15">
      <v-stepper
        alt-labels
        v-model="stpr"
        class="transparent elevation-0 px-md-16"
      >
        <v-stepper-header
          class="elevation-0 w-100 body-color z-2 position-fixed px-md-18"
          style="top: 56px"
        >
          <template v-for="step in steps">
            <v-stepper-step
              :key="`${step.id}-step`"
              :complete="stpr >= step.number"
              :editable="stpr == step.number ? true : false"
              step=""
              class="caption-regular px-3 my-4 pt-05 pb-05"
              :class="stpr == step.number && 'outline-border'"
              color="var(--logistic)"
            >
              {{ step.name }}
            </v-stepper-step>

            <v-divider
              v-if="step.number !== steps.length"
              :key="step.id"
            ></v-divider>
          </template>
        </v-stepper-header>

        <v-stepper-items class="mt-20">
          <v-stepper-content
            v-for="step in steps"
            :key="`${step.id}-content`"
            :step="step.number"
            class="pa-0 nav-spacer"
          >
            <keep-alive>
              <!-- Dynamic components could be Identity, LoadDetail or Date -->
              <component
                :is="step.component"
                :type="step.type"
                :load="load"
                :stpr="stpr"
                :permissions="permissions"
              ></component>
            </keep-alive>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <v-bottom-navigation
      fixed
      class="elevation-1 px-2 px-lg-20"
      style="height: 68px"
    >
      <v-col cols class="my-auto py-0 px-2">
        <span
          class="btn-height border border-grey d-flex justify-center align-center logistic--text rounded py-6 button-medium"
          @click="prevStep(stpr)"
          v-text="stpr == 1 ? 'انصراف' : 'قبلی'"
        >
        </span>
      </v-col>

      <v-col cols class="my-auto py-0 px-2">
        <v-btn
          style="color: #ffffff"
          light
          class="btn-height logistic-color white--text rounded d-flex justify-center align-center py-6 button-medium"
          :disabled="!this.permissions[stpr - 1]"
          :loading="isLoading"
          @click.prevent="nextStep(stpr)"
        >
          <span
            v-text="stpr == steps.length ? 'اعلام بار' : 'مرحله بعد'"
          ></span>
          <v-icon class="mr-2" color="white">mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
    </v-bottom-navigation>

    <snackbar></snackbar>
  </div>
</template>

<script>
import Identity from "../components/newLoadSteps/Identity";
import LoadDetail from "../components/newLoadSteps/LoadDetail.vue";
import Date from "../components/newLoadSteps/Date.vue";

export default {
  name: "newLoad",
  components: { Identity, LoadDetail, Date },
  data() {
    return {
      reorder: true,
      stpr: 1,
      steps: [
        {
          id: 1001,
          name: "بارگیری",
          number: 1,
          component: "Identity",
          type: "sender",
        },
        {
          id: 1002,
          name: "تخلیه",
          number: 2,
          component: "Identity",
          type: "receiver",
        },
        {
          id: 1003,
          name: "مشخصات بار",
          number: 3,
          component: "LoadDetail",
          type: null,
        },
        {
          id: 1004,
          name: "اطلاعات بار",
          number: 4,
          component: "Date",
          type: null,
        },
      ],
      load: {
        dimensions: [],
        // temp values
        drivers_count: 1,
        drivers_time_type: "all",
        location: null,
        tonnage_type: 1,
      },
      isLoading: false,
      permissions: [false, false, false, false],
    };
  },

  created() {
    this.$store.commit("setPageTitle", "اعلام بار جدید");
  },

  computed: {
    title() {
      return this.$store.state.pageTitle;
    },
  },

  methods: {
    async submit() {
      this.isLoading = true;
      let submitData = this.load;
      submitData.companyId = localStorage.getItem("companyId");
      // convert to rial
      submitData.price = submitData.price * 10;
      //convert to standard vehicle array list
      submitData.vehicle = this.$utils.standardMultiVehicleList(
        submitData.vehicle
      );

      const res = await this.$parseSDK.Cloud.run(
        "submit_company_load_array",
        submitData
      ).catch((err) => {
        if (err.message === 209) {
          this.$utils.showMessage("لطفا دوباره لاگین کنید", {
            type: "error",
          });

          return this.$store.commit("log_out", { showGoodBye: false });
        }

        let msg = "خطایی رخ داده است";

        if (err.message === 2025) {
          msg = "کیف پول شما غیرفعال است";
        } else if (err.message === 2031) {
          msg = "شارژ کیف پول شما منفی است";
        }

        this.$store.commit("showSnackbar", {
          text: msg,
        });

        this.load.price /= 10;
        this.load.vehicle = this.$utils.unstandardizedVelicles(
          submitData.vehicle
        );

        this.isLoading = false;
      });

      if (res) {
        this.$utils.showMessage("اعلام بار با موفقیت ثبت شد", {
          type: "success",
        });

        setTimeout(() => {
          this.$router.push("/Panel/LoadManagement").catch(() => true);
        }, 0);
      }
    },
    nextStep(n) {
      if (n >= this.steps.length) {
        this.submit();
        return;
      }
      this.stpr = n + 1;
      this.scrollTop();
    },
    prevStep(n) {
      if (n <= 1) {
        this.$router.push("LoadManagement");
        return;
      }
      this.stpr = n - 1;
      this.scrollTop();
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
    backToLoads() {
      this.$router.push("loadManagement").catch(() => {});
    },
  },
};
</script>

<style scoped>
.outline-border {
  pointer-events: none;
}
.outline-border >>> span {
  background-color: #f5f5f5 !important;
  box-shadow: 0 0 0 1px var(--logistic) !important;
}
.outline-border >>> span .mdi-pencil {
  color: var(--logistic) !important;
}
.border.border-grey {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.btn-height {
  height: 2.5rem !important;
  cursor: pointer;
}
.mt-20 {
  margin-top: 5.4rem;
}
@media (min-width: 960px) {
  .px-md-18 {
    padding-right: 26vw !important;
    padding-left: 26vw !important;
  }
}

@media (min-width: 1200px) {
  .px-lg-20 {
    padding-right: 28rem !important;
    padding-left: 28rem !important;
  }
}
</style>
